import Notification from "../../../components/NotificationMenu/Notification";

function NotificationList({
  items,
  emptyMessage,
  onItemClick,
  onMenuAction,
  selectedIds = [],
  onToggleSelect,
  onSelectAll,
  onBulkMarkRead,
  onBulkMarkUnread,
  onBulkDelete,
}) {
  const hasItems = items && items.length > 0;
  const selectedCount = selectedIds.length;
  const allSelected =
    hasItems && items.every((n) => selectedIds.includes(n.id));
  const someSelected = selectedCount > 0;

  if (!hasItems) {
    return (
      <div className="p-4 text-center text-muted small">{emptyMessage}</div>
    );
  }

  return (
    <div>
      <div
        className="d-flex align-items-center flex-wrap gap-0 bg-white border-bottom"
        style={{ minHeight: "40px" }}
      >
        <div className="d-flex align-items-center gap-2 px-3 py-2 flex-shrink-0">
          <input
            type="checkbox"
            className="form-check-input"
            checked={allSelected}
            onChange={(e) => onSelectAll?.(e.target.checked, items)}
            aria-label="Select all on this tab"
          />
          <span className="small text-muted">Select all</span>
        </div>
        <div
          className="flex-grow-1 align-self-stretch"
          style={{ borderLeft: "1px solid var(--bs-border-color)" }}
          aria-hidden
        />
        <div className="d-flex align-items-center flex-wrap gap-2 px-3 py-2 flex-shrink-0 small">
          {someSelected ? (
            <>
              <span className="text-muted">{selectedCount} selected</span>
              <button
                type="button"
                className="btn btn-sm btn-outline-primary"
                onClick={onBulkMarkRead}
              >
                Mark as read
              </button>
              <button
                type="button"
                className="btn btn-sm btn-outline-secondary"
                onClick={onBulkMarkUnread}
              >
                Mark as unread
              </button>
              <button
                type="button"
                className="btn btn-sm btn-outline-danger"
                onClick={onBulkDelete}
              >
                Delete
              </button>
              <button
                type="button"
                className="btn btn-sm btn-link text-muted p-0"
                onClick={() => onSelectAll(false, items)}
              >
                Clear
              </button>
            </>
          ) : null}
        </div>
      </div>
      <ul
        className="list-group list-group-flush"
        style={{ maxHeight: "360px", overflowY: "auto" }}
      >
        {items.map((notif) => (
          <Notification
            key={notif.id}
            notification={notif}
            onClick={onItemClick ? () => onItemClick(notif) : undefined}
            onMenuAction={onMenuAction}
            selectable
            selected={selectedIds.includes(notif.id)}
            onSelectChange={() => onToggleSelect?.(notif)}
            {...notif}
          />
        ))}
      </ul>
    </div>
  );
}

export default NotificationList;
